module.exports = __webpack_public_path__ + "static/img/iconmenu05_white.e4194118.svg";